import { atom } from 'jotai'

export type AccommodationItem = {
  type: 'accommodation'
  name: string
  image?: AddedToCartItemImage
  startDate: string
  startTimezone?: string | null
  endDate: string
  endTimezone?: string | null
}

export type ExperienceItem = {
  type: 'experience'
  name: string
  image?: AddedToCartItemImage
  startDate: string
  startTimezone?: string | null
  endDate?: string
  endTimezone?: string | null
  timeRange?: string
  tickets?: string
}

export type BeachChairItem = {
  type: 'beachChair'
  name: string
  image?: AddedToCartItemImage
  startDate: string
  startTimezone?: string | null
  endDate: string
  endTimezone?: string | null
}

export type BikeItem = {
  type: 'bike'
  name: string
  startDate: string
  startTimezone?: string | null
  endDate: string
  endTimezone?: string | null
  products: {
    bikeCount: number
    extrasCount: number
  }
}

type AddedToCartItemImage = {
  url: string
  alt: string
}

export type AddedToCartItem = AccommodationItem | ExperienceItem | BeachChairItem | BikeItem

export const addedToCartItemsAtom = atom<AddedToCartItem[] | null>(null)

type ExperienceLike = {
  title: string
  images?: { url: string; alt?: string | null }[] | null | undefined
}

type ExperienceTimeslotLike = {
  startDate: string
  startTimezone?: string | null
  timeRange?: string
  tickets?: string
}

export function buildExperienceCartItem(
  experience: ExperienceLike,
  timeslot: ExperienceTimeslotLike
): ExperienceItem {
  const [image] = experience.images ?? []
  return {
    type: 'experience',
    name: experience.title,
    image: image && { url: image.url, alt: image.alt ?? experience.title },
    startDate: timeslot.startDate,
    startTimezone: timeslot.startTimezone,
    timeRange: timeslot.timeRange,
    tickets: timeslot.tickets,
  }
}
